import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLightTheme, setDarkTheme, toggleSystemTheme } from '../../store/themeSlice';
import MoonIcon from '../svg/MoonIcon';

import { RootState } from '../../store/indexRedux';
import SunIconOutline from '../svg/SunIconOutline';
import SunIconSolid from '../svg/SunIconSolid';
import MonitorIconSolid from '../svg/MonitorIconSolid';
import MonitorIconOutline from '../svg/MonitorIconOutline';

const ThemeOptions: React.FC = () => {
  const dispatch = useDispatch();
  const theme = useSelector((state: RootState) => state.theme.theme);
  const [activeIcon, setActiveIcon] = useState<string | null>(null);

  useEffect(() => {
    const systemThemeActivated = localStorage.getItem('systemThemeActivated');
    const storedTheme = localStorage.getItem('theme');

    if (systemThemeActivated) {
      setActiveIcon('monitor');
    } else if (storedTheme === 'mytheme') {
      setActiveIcon('sun');
    } else if (storedTheme === 'dark') {
      setActiveIcon('moon');
    }
  }, [theme]);

  const handleIconClick = (icon: string) => {
    setActiveIcon(icon);
    switch (icon) {
      case 'sun':
        dispatch(setLightTheme());
        break;
      case 'moon':
        dispatch(setDarkTheme());
        break;
      case 'monitor':
        dispatch(toggleSystemTheme());
        break;
      default:
        break;
    }
  };
  return (
    <div className='inline-flex cursor-pointer child:text-primary-300 bg-[#FAFAFC] dark:bg-primary-950 rounded-md child:py-3 child:px-[1.35rem] child:rounded-md '>
      <div
        onClick={() => handleIconClick('sun')}
        className={`hover:bg-gray-100 dark:bg-primary-950 hover:text-primary-600 dark:hover:bg-gray-100 tooltip tooltip-primary group ${
          activeIcon === 'sun' ? 'bg-primary-600 hover:bg-primary-600 text-primary-50' : 'text-primary-300'
        }`}
        data-tip='Light Mode'
      >
        {activeIcon === 'sun' ? (
          <span className='text-primary-50'>
            <SunIconSolid />
          </span>
        ) : (
          <span className='group-hover:text-primary-400 dark:text-primary-500'>
            <SunIconOutline />
          </span>
        )}
      </div>

      <div
        onClick={() => handleIconClick('moon')}
        className={`hover:bg-gray-100  hover:text-primary-600 tooltip tooltip-primary group ${
          activeIcon === 'moon' ? 'bg-primary-600 dark:hover:bg-primary-600 text-primary-50' : 'text-primary-300'
        }`}
        data-tip='Dark Mode'
      >
        {activeIcon === 'moon' ? (
          <span className='text-primary-50'>
            <MoonIcon fillColor='currentColor' />
          </span>
        ) : (
          <span className='group-hover:text-primary-400 dark:text-primary-500'>
            <MoonIcon fillColor='none' />
          </span>
        )}
      </div>

      <div
        onClick={() => handleIconClick('monitor')}
        className={`hover:bg-gray-100  hover:text-primary-600 dark:hover:bg-gray-100 tooltip tooltip-primary group ${
          activeIcon === 'monitor'
            ? 'bg-primary-600 hover:bg-primary-600 dark:hover:bg-primary-600 text-primary-50'
            : 'text-primary-300'
        }`}
        data-tip='System setting'
      >
        {activeIcon === 'monitor' ? (
          <span className='text-primary-50'>
            <MonitorIconSolid />
          </span>
        ) : (
          <span className='group-hover:text-primary-400 dark:text-primary-500'>
            <MonitorIconOutline />
          </span>
        )}
      </div>
    </div>
  );
};

export default ThemeOptions;
